import { Button, Grid, Paper, Typography } from "@mui/material";
import Images from "../UserModal/Images";
import { IAttempt } from "../../types/images";
import moment from "moment";

interface AttemptProps {
  attempt: IAttempt;
  index: number;
  setAttemptIndex(attempt: number): void;
  setFullScreen(screen: boolean): void;
}

export function Attempt(props: AttemptProps) {
  const { attempt, index, setAttemptIndex, setFullScreen } = props;

  const imgSize = attempt.images.selfieRef || attempt.images.document ? 6 : 12;

  return (
    <Paper>
      <Grid
        container
        direction="row"
        justifyContent="space-evenly"
        alignItems="flex-start"
        textAlign="center"
        // sx={{ border: "solid green 1px" }}
      >
        <Grid item xs={12} xl={12}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {attempt.info.Status.toUpperCase()}
          </Typography>
        </Grid>
        <Grid item xs={12} xl={12} sx={{}}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {moment(attempt.info.Date).format("DD MMMM YYYY")}
          </Typography>
        </Grid>
        <Button
          sx={{ margin: "auto" }}
          onClick={() => {
            setAttemptIndex(index);
            setFullScreen(true);
          }}
        >
          FullScreen
        </Button>
        <Grid item xs={12} xl={12}>
          <Images
            imgHeight={300}
            images={attempt.images}
            imgSize={imgSize}
            imgControl={false}
            // showContraols={"none"}
            // onWheel={undefined}
          />
        </Grid>
        <Grid item xs={12} xl={12} sx={{}}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Source: {attempt.info.requestSource}
          </Typography>
        </Grid>
        {attempt.info.Rejection_Couse ? (
          <Grid item xs={12} xl={12} sx={{}}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Rejection Cause
            </Typography>
            <Typography>{attempt.info.Rejection_Couse}</Typography>
          </Grid>
        ) : (
          <Grid item xs={12} xl={12} sx={{}}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Rejection Cause
            </Typography>
            <Typography>None</Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}
